import { put, takeLatest, fork } from 'redux-saga/effects';
import { call, select, take } from 'typed-redux-saga';
import { getLocalStorageItem, removeLocalStorageItem } from 'libs/utils/localStorage';
import { SAVED_ITEM_STORAGE_KEY, PUSHED_ITEM_STORAGE_KEY, FEEDBACK_ITEM_ID } from 'constants/storage';
import { ExtraServiceCheckoutModal } from 'constants/extra-service';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { actions as bumpActions } from 'state/bump/slice';
import * as bumpSelectors from 'state/bump/selectors';
import { getPushUpsAvailability } from 'state/bump/sagas';
import { getShowItemUploadFeedback } from 'data/api';
import { actions } from './slice';
import * as statelessActions from './actions';
import * as selectors from './selectors';
import { PromoAfterItemUpload } from './constants';
export function* readLocalStorageIntoState() {
  const newItemIdFromStorage = yield* call(getLocalStorageItem, SAVED_ITEM_STORAGE_KEY);
  const newItemId = parseInt(newItemIdFromStorage || '', 10);

  if (newItemId) {
    yield* call(removeLocalStorageItem, SAVED_ITEM_STORAGE_KEY);
    yield put(actions.setUploadedItemId({
      id: newItemId
    }));
  }

  const pushedUpItemIdFromStorage = yield* call(getLocalStorageItem, PUSHED_ITEM_STORAGE_KEY);
  const pushedUpItemId = parseInt(pushedUpItemIdFromStorage || '', 10);

  if (pushedUpItemId) {
    yield* call(removeLocalStorageItem, PUSHED_ITEM_STORAGE_KEY);
    yield put(actions.setUploadedItemPushedUpId({
      id: pushedUpItemId
    }));
  }

  const feedbackItemIdFromStorage = yield* call(getLocalStorageItem, FEEDBACK_ITEM_ID);
  const feedbackItemId = parseInt(feedbackItemIdFromStorage || '', 10);

  if (feedbackItemId) {
    yield* call(removeLocalStorageItem, FEEDBACK_ITEM_ID);
    yield put(actions.setFeedbackItemId({
      id: feedbackItemId
    }));
  }
}
export function* startPushUpOnUploadForm() {
  const pushedUpItemId = yield* select(selectors.getUploadedItemPushedUpId);

  if (!pushedUpItemId) {
    yield put(statelessActions.nextPromoAfterItemUpload());
    return;
  }

  const checkoutModal = yield* select(bumpSelectors.getActiveCheckoutModal);

  if (checkoutModal !== ExtraServiceCheckoutModal.None) {
    return;
  }

  let pushUpOption = yield* select(bumpSelectors.getCheapestPushUpOption);

  if (!pushUpOption) {
    yield* call(getPushUpsAvailability);
    pushUpOption = yield* select(bumpSelectors.getCheapestPushUpOption);

    if (!pushUpOption) {
      yield put(statelessActions.nextPromoAfterItemUpload());
      return;
    }
  }

  yield put(bumpActions.setSelectedItems({
    itemIds: [pushedUpItemId]
  }));
  yield put(bumpActions.setCheckoutModal({
    modal: ExtraServiceCheckoutModal.OrderReview
  }));
  yield put(bumpActions.setSelectedPushUpOption({
    selectedPushUpOption: pushUpOption
  }));
  yield put(actions.setCurrentPromotionAfterItemUpload({
    promo: PromoAfterItemUpload.PushUpCheckout
  }));
}
export function* startListAnotherPromo() {
  yield put(actions.setCurrentPromotionAfterItemUpload({
    promo: PromoAfterItemUpload.ListAnotherItem
  }));
}
export function* startItemUploadFeedbackPromo() {
  const isFeedbackEnabled = yield* select(getIsFeatureSwitchEnabled('item_upload_feedback_form'));
  const feedbackItemId = yield select(selectors.getFeedbackItemId);

  if (!feedbackItemId || !isFeedbackEnabled) {
    yield put(statelessActions.nextPromoAfterItemUpload());
    return;
  }

  const response = yield* call(getShowItemUploadFeedback);

  if ('errors' in response || !response.show_feedback) {
    yield put(statelessActions.nextPromoAfterItemUpload());
    return;
  }

  yield put(actions.setCurrentPromotionAfterItemUpload({
    promo: PromoAfterItemUpload.ItemUploadFeedback
  }));
}
export function* startPromosAfterItemUpload() {
  yield call(readLocalStorageIntoState);
  yield fork(startPushUpOnUploadForm);
  yield take(statelessActions.nextPromoAfterItemUpload);
  yield fork(startListAnotherPromo);
  yield take(statelessActions.nextPromoAfterItemUpload);
  yield fork(startItemUploadFeedbackPromo);
  yield take(statelessActions.nextPromoAfterItemUpload);
  yield put(actions.setCurrentPromotionAfterItemUpload({
    promo: PromoAfterItemUpload.Empty
  }));
}
export default function* saga() {
  yield takeLatest(statelessActions.startPromosAfterItemUpload, startPromosAfterItemUpload);
}